import {LocalizedValue} from '../standard/localized-value';

export class NotificationData {

  constructor(public notificationType: string, public subject: LocalizedValue[],
              public body: LocalizedValue[]) {}

}
